import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AppProvider from "context/AppProvider";
import { initGA, initSentry } from "utils/analytics";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

initGA();
initSentry();

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
